import { deepLinkService } from "../deeplink/DeepLinkService";

/**
 * Get the redirect URL for SA login.
 *
 * Returns the authRedirect (whitelist-safe path without ticket segment)
 * from the pending deep link stored in localStorage. This survives
 * cross-domain SA portal redirects, unlike the old sessionStorage approach.
 *
 * If no pending deep link exists, returns "/" as default.
 */
export const getRedirectUrl = () => {
  const deepLink = deepLinkService.get();
  if (!deepLink) {
    return "/";
  }
  return deepLink.authRedirect;
};
